import { Component, forwardRef, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-paginator',
  templateUrl: 'paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PaginatorComponent),
      multi: true,
    }
  ]
})

export class PaginatorComponent implements OnInit, ControlValueAccessor {
  currentPage = 1;
  totalPages: number;

  onChange = (_: any) => { };
  onTouched = () => { };
  isDisabled: boolean;

  constructor() { }

  ngOnInit() { }

  onChangePage(option: 1 | 2 | 3 | 4) {
    if (option) {
      if (option === 1) { // Previus
        this.currentPage--;
      } else if (option === 2) { // Next
        this.currentPage++;
      } else if (option === 3) { // First
        this.currentPage = 1;
      } else if (option === 4) { // Last
        this.currentPage = this.totalPages;
      }
      this.onTouched();
      this.onChange(this.currentPage);
    }
  }

  get isFirstPage(): boolean {
    return this.currentPage === 1 ? true : false;
  }

  get isLastPage(): boolean {
    return this.currentPage === this.totalPages ? true : false;
  }

  writeValue(obj: any): void {
    if (obj) {
      this.totalPages = obj.totalPages;
      this.currentPage = obj.currentPage;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/paginator/paginator/paginator.component.ts